import { setToken } from '../authentication';
import { axiosClientApi } from '../../axiosClientConfiguration';
import { postRequest } from '../../axiosFunctions';

const MpState = {
  Open: "OPEN",
  OnTerminal: "ON_TERMINAL",
  Processing: "PROCESSING",
  Finished: "FINISHED",
  Canceled: "CANCELED",
  Abandoned: "ABANDONED",
};


const requestData = {
  saleCode: undefined,
  branchName: undefined,
  amount: undefined,
  printReceipt: undefined,
}

const requestBindData = {
  saleId: undefined,
  intentId: undefined,
}


const postMpProcessPointFlow = (token, data, controller) => {
  return postRequest(
    axiosClientApi,
    "/Payment/MpProcessPointFlow",
    data,
    setToken(token, controller)
  );
}

const postMpBindSale = (token, data, controller) => {
  return postRequest(
    axiosClientApi,
    "/Payment/MpBindSale",
    data,
    setToken(token, controller)
  );
}

export const Payment = {
  requestData,
  requestBindData,  
  MpState,
  postMpProcessPointFlow,
  postMpBindSale,
};

